module.exports = __webpack_public_path__ + "img/dly-icon-01.432eec39.png";